module.exports = __webpack_public_path__ + "static/25-f056345299493e31140094f9304fbe9c.png";